// const BASEURL = "https://kessler.avenu.ai/api/";
// const BASEURL = "https://devon.avenu.ai/backend/api/";
const BASEURL = process.env.REACT_APP_API_URL;
const RECUITMENTURL = process.env.REACT_APP_RECUITMENT_URL;

export const API = {
  login: BASEURL + "login",
  getAllApplications: BASEURL + "chatbots-anwers-list",
  fetchMyTeam: BASEURL + "my-team-list",
  getChatbotsAnwers: BASEURL + "chatbots-anwers",
  updateApplicants: BASEURL + "applicants-update",
  updatemyTeamApplicantStatus: BASEURL + "my-team-update-status",
  archiveEmployee: BASEURL + "applicants-delete-by-admin",
  removeTags: BASEURL + "applicants-remove-tag",
  getApplicantsbyId: BASEURL + "applicants-get-interview-data",
  getSections: BASEURL + "onboarding-get-sections-data",
  getJobs: BASEURL + "chatbots-get-chatbots-by-owner",
  getCompanyJobs: BASEURL + "chatbots-get-based-on-companies",
  uploadMedia: BASEURL + "onboarding-upload-single-media",

  // devon
  // zipDownloadView: "https://devon.avenu.ai/backend/storage/",
  // mediaView: "https://devon.avenu.ai/backend/storage/app/public/",
  // avenuView: "https://dev.avenu.ai/storage/",
  // legalFormsView: "https://docsavenu.sicsglobal.com/PDF/",
  // sendMessage: "https://dev.avenu.ai/onboarding-interviewer-message",
  // getMessages: "https://dev.avenu.ai/onboarding-get-all-conversations/",
  // getNewMessages:
  //   "https://dev.avenu.ai/onboarding-fetch-new-sms-conversations/",
  // getMessageCount:
  //   "https://dev.avenu.ai/onboarding-fetch-new-sms-conversations-count/",

  //beta
  // mediaView: " https://doc.avenu.ai/storage/",
  // avenuView: "https://app.avenu.ai/storage/",
  // legalFormsView: "http://docs.avenu.ai/PDF/",
  // sendMessage: "https://app.avenu.ai/onboarding-interviewer-message",
  // getMessages: "https://app.avenu.ai/onboarding-get-all-conversations/",
  // getNewMessages:
  //   "https://app.avenu.ai/api/onboarding-fetch-new-sms-conversations/",
  // getMessageCount:
  //   "https://app.avenu.ai/onboarding-fetch-new-sms-conversations-count/",

  // CI/CD
  mediaView: process.env.REACT_APP_MEDIA_URL,
  onboardingS3View: BASEURL + "onboarding-get-s3Image-URL",
  avenuView: RECUITMENTURL + "storage/",
  legalFormsView: process.env.REACT_APP_LEGAL_VIEW,
  getMessages: RECUITMENTURL + "onboarding-get-all-conversations/",
  sendMessage: RECUITMENTURL + "onboarding-interviewer-message",
  getNewMessages: RECUITMENTURL + "onboarding-fetch-new-sms-conversations/",
  getMessageCount:
    RECUITMENTURL + "onboarding-fetch-new-sms-conversations-count/",
  zipDownloadView: process.env.REACT_APP_ZIP_URL,

  changeSectionOrder: BASEURL + "onboarding-change-section-order",
  changeTempSectionOrder:
    BASEURL + "onboarding-change-template-seequence-order",
  changeFormOrder: BASEURL + "onboarding-change-form-order",
  changeTempFormOrder: BASEURL + "onboarding-change-template-sectionform-order",
  createForm: BASEURL + "onboarding-create-form",
  createTempForm: BASEURL + "onboarding-create-template-sectionform",
  copyTempPDF: BASEURL + "onboarding-create-copy-conveted-docs",
  copyTempSection: BASEURL + "onboarding-create-copy-onboarding-templates",
  copyTempForm: BASEURL + "onboarding-create-copy-form-template",
  editForm: BASEURL + "onboarding-edit-form",
  editCandidateForm: BASEURL + "applicants-edit-form",
  deleteForm: BASEURL + "onboarding-delete-section-data",
  deleteTempForm: BASEURL + "onboarding-delete-template-sectionform",
  deleteComponents: BASEURL + "onboarding-delete-form-component",
  addSection: BASEURL + "onboarding-add-section",
  addTemplateSection: BASEURL + "onboarding-add-template-section",
  deleteSection: BASEURL + "onboarding-delete-section",
  deleteSectionById: BASEURL + "applicants-delete-section",
  deleteTempSection: BASEURL + "onboarding-delete-template-sections",
  updateTempName: BASEURL + "onboarding-update-template-section-name",
  updateFormTempName: BASEURL + "onboarding-update-template-form-name",
  updatePDFTempName: BASEURL + "onboarding-update-converted-doc-name",
  addCandidate: BASEURL + "applicants-add-by-admin",
  addCandidateToMyTeam: BASEURL + "my-team-add-employee",
  getCandidateSections: BASEURL + "candidateonboarding-chatbot-sections",
  getReviewSections: BASEURL + "candidateonboarding-chatbot-review",
  onboardingUpdate: BASEURL + "onboarding-options-update",
  onboardingTempUpdate: BASEURL + "onboarding-update-template-options",
  getTemplateById: BASEURL + "onboarding-templates-by-id",
  getFormById: BASEURL + "onboarding-form-by-id",
  getTemplateFormById: BASEURL + "onboarding-template-form-by-id",
  getTemplates: BASEURL + "onboarding-templates",
  getTemplateDetails: BASEURL + "onboarding-templates-view",
  editTemplate: BASEURL + "onboarding-edit-template-form",
  copyTemplate: BASEURL + "onboarding-edit-template-copy",
  saveSectionTemplates: BASEURL + "onboarding-save-section-template",
  createSectionTemplates: BASEURL + "onboarding-create-section-template",
  importSectionTemplates: BASEURL + "onboarding-import-section-template",
  getSectionTemplates: BASEURL + "onboarding-section-templates",
  getDocuments: BASEURL + "filelibrary-applicant-files",
  deleteFormTemplate: BASEURL + "onboarding-delete-form-template",
  deleteSectionTemplate: BASEURL + "onboarding-section-deletetemplates",
  deleteMultipleTemplates: BASEURL + "onboarding-delete-converted-forms-docs",
  onboardingTemplatesView: BASEURL + "onboarding-templates-view",
  assignTemplate: BASEURL + "onboarding-assign-template-company",
  assignFormTemplate: BASEURL + "onboarding-assign-form-template-company",
  assignPDFTemplate: BASEURL + "onboarding-assign-conveted-docs",
  renameTemplateSection: BASEURL + "onboarding-update-template-section",
  renameTemplateSubSection: BASEURL + "onboarding-update-template-subsection",
  deleteDoc: BASEURL + "filelibrary-delete-applicant-document",
  getCompanyList: BASEURL + "chatbots-Filter-list",
  toggleAdvance: BASEURL + "change-advanced-mode",
  downloadZip: BASEURL + "Download-zip-file",

  //file library
  fetchLists: BASEURL + "filelibrary-list-subfolders",
  deleteListItem: BASEURL + "filelibrary-delete-document",
  fetchGroups: BASEURL + "filelibrary-list-groups",
  addGroup: BASEURL + "filelibrary-create-group",

  //candidates
  fetchOnboardingStatus: BASEURL + "applicants-onboarding-status",
  uploadFile: BASEURL + "candidateonboarding-upload-document",
  saveForm: BASEURL + "candidateonboarding-save-form",
  confirmForm: BASEURL + "candidateonboarding-confirm-form",
  resetForm: BASEURL + "candidateonboarding-reset-form",
  resetSection: BASEURL + "candidateonboarding-reset-section",
  resetOnboarding: BASEURL + "candidateonboarding-reset-onboarding",
  fetchApplicationHistory: BASEURL + "applicants-application-history",
  updateStatus: BASEURL + "applicants-change-interviewee-status",
  sendForms: BASEURL + "my-team-send-form",
  getDocumentUrl: BASEURL + "chatbots-anwers-download",
  createTemplate: BASEURL + "onboarding-create-template",
  renameSection: BASEURL + "onboarding-update-section",
  renameSectionSubtitle: BASEURL + "onboarding-update-section-subtitle",
  uploadDoc: BASEURL + "applicants-upload-document",
  reviewCandidate: BASEURL + "candidateonboarding-client-review",
  checkEmail: BASEURL + "applicants-check-interviewee-email-exist",
  checkPhone: BASEURL + "applicants-check-interviewee-phone-exist",
  editDetails: BASEURL + "applicants-edit-by-admin",
  candidateSaveConvertedDocument:
    BASEURL + "candidateonboarding-save-converted-document",
  getConvertedDocument: BASEURL + "candidateonboarding-get-converted-document",
  applicantsGetConvertedDocument: BASEURL + "applicants-get-converted-document",
  applicantsEditConvertedDocument:
    BASEURL + "applicants-edit-converteddocument",
  getPreviewConvertedDocument: BASEURL + "onboarding-get-converted-document",
  onboardingGetSectionConvertedDocument:
    BASEURL + "onboarding-get-section-converted-document",
  onboardingGetTemplateConvertedDocument:
    BASEURL + "onboarding-get-template-section-converted-document",
  onboardingGetFormTemplateConvertedDocument:
    BASEURL + "onboarding-edit-converted-document",
  saveConvertDocument: BASEURL + "onboarding-save-converted-document",
  onboardingUpdateSectionConvertedDocument:
    BASEURL + "onboarding-update-section-converted-document",
  onboardingUpdateSectionTemplateConvertedDocument:
    BASEURL + "onboarding-update-template-section-converted-document",
  saveConvertDocumentEdit: BASEURL + "onboarding-update-converted-document",
  deleteConvertDocument: BASEURL + "onboarding-delete-converted-document",
  getConfirmedDoc: BASEURL + "download-pdf-documents",
  overrideForm: BASEURL + "applicants-override-form",
  getI9DocTypes: BASEURL + "get-documnet-types",
  getI9countries: BASEURL + "get-Everify-countries",
  everifyI9form: BASEURL + "i9-everify-document",
  reverifyI9form: BASEURL + "confirm-everify-i9-data",
  getReasons: BASEURL + "get-Everify-delayReasons",
  downloadForm: BASEURL + "applicants-download-i9-form",
  listCases: BASEURL + "listCases",
  caseDetails: BASEURL + "CaseDetails",
  getCloseCaseReasons: BASEURL + "closureReasons",
  closeCase: BASEURL + "closeCase",
  duplicateReasons: BASEURL + "duplicateReasons",
  downloadfurtherAction: BASEURL + "downloadfurtherAction",
  referCase: BASEURL + "referCase",
  noAction: BASEURL + "noAction",
  downloadReferalDateConfirmation: BASEURL + "downloadReferalDateConfirmation",
  continueCase: BASEURL + "candidateonboarding-ContinueCase",
  photoMatch: BASEURL + "photomatch",
  scanandUpload: BASEURL + "scan_and_upload",
  getToken: BASEURL + "CreateToken",
  updateCaseStatus: BASEURL + "update-Case-Status",
  redirectToEverify: BASEURL + "redirect-to-everify",
  updateFieldValue: BASEURL + "update-field-value",

  //edit form
  fetchOnboardingTemplates: BASEURL + "onboarding-templates",
  saveTemplateToForm: BASEURL + "onboarding-save-template-to-form",
  saveTemplateToOnboardingForm:
    BASEURL + "onboarding-save-template-sectionform",
  employerConfirm: BASEURL + "candidateonboarding-save-pdf-document",

  //verification
  sendVerification: BASEURL + "candidateonboarding-send-otp-to-interviewee",
  verifyOtp: BASEURL + "candidateonboarding-verify-otp",
  sendEverifyRequest: BASEURL + "everify-mail-activate",

  getFields: BASEURL + "applicants-custom-form-labels",
  updateFields: BASEURL + "applicants-custom-form-update",
};
